import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";

export const FooterContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    height: 148px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: ${theme.spacings.lg} 0;
    grid-area: footer;
  `}
`;
